import { render } from "./Dashboard.vue?vue&type=template&id=68ea87ee&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=68ea87ee&lang=css"
import "./Dashboard.vue?vue&type=style&index=1&id=68ea87ee&scoped=true&lang=css"

import exportComponent from "/var/www/bauminas/prod/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68ea87ee"]])

export default __exports__